import TableChartIcon from "@mui/icons-material/TableChart";
import CustomQR from "./custom_qr";
export const inf_partner_qr = [
  {
    label: "Table",
    accessor: "data_businesspartners",
    sm: 30,
    dfl: "",
    type: "custom",
    data_select: [],
    name_select: "",
    section: "custom",
    sectionTitle: "Puntos de venta",
    change: false,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    customComponent: CustomQR,
    method: "ALL-CUSTOM",
    icon: TableChartIcon,
  },
];
